import { QuizStats } from "@/context/QuizContext";
import Choice from "./Choice";
import Question from "./Question";

function QandA({ register }) {
  const { currentQuestionData, loadingQuiz } = QuizStats()

  if (loadingQuiz) return null

  const question = currentQuestionData?.attributes.question;
  const image = currentQuestionData?.attributes?.image;
  const options = currentQuestionData?.options;

  return (
    <>
      <Question question={question} image={image} />

      <div className="grid w-full gap-6 py-5 md:grid-cols-2">
        {options && options.map((option, index) => {
          return (
            <Choice
              choice={option}
              optionNum={index}
              key={option.id}
              register={register}
            />
          );
        })}
      </div>
    </>
  );
}

export default QandA;
